export { default } from "./linkActionCard";
